const ALERTABLE_STATUSES = new Set(['disconnected', 'failed']);

export const findDisconnectedAccessibleInstances = instances => {
  if (!Array.isArray(instances)) return [];

  // A API já remove as instâncias fora do escopo do usuário. `can_manage` e
  // `can_reconnect` controlam ações, não a visibilidade do aviso: membros com
  // acesso a uma instância compartilhada também precisam ser alertados.
  return instances.filter(
    instance =>
      instance?.can_view !== false && ALERTABLE_STATUSES.has(instance.status)
  );
};

// Quem escolheu "Não mostrar mais" para a queda em curso. A marca é da inbox,
// gravada no Aceleres, e deixa de valer sozinha quando ela reconecta.
export const isDisconnectAlertMuted = instance =>
  Boolean(instance?.disconnect_alert_muted);

export const DISCONNECT_ALERT_MUTE_OPTIONS = [
  { value: '8h', label: 'Por 8 horas' },
  { value: '1d', label: 'Por 1 dia' },
  { value: '7d', label: 'Por 7 dias' },
  { value: '30d', label: 'Por 30 dias' },
  { value: 'forever', label: 'Para sempre' },
];

export const DISCONNECT_ALERT_UNDO_HINT =
  'Para voltar a ser avisado, abra Integrações e clique em “Reativar aviso” no cartão desta conexão. Se ela reconectar, o aviso volta sozinho numa próxima queda.';

export const disconnectAlertMutedLabel = instance => {
  if (!isDisconnectAlertMuted(instance)) return '';
  const until = instance.disconnect_alert_muted_until;
  if (!until) return 'Aviso de desconexão desativado';

  const date = new Date(until);
  if (Number.isNaN(date.getTime())) return 'Aviso de desconexão silenciado';

  return `Aviso silenciado até ${date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};

export const findDisconnectedAccessibleInstance = instances =>
  findDisconnectedAccessibleInstances(instances)[0] || null;

export const disconnectedInstanceTypeLabel = type => {
  const labels = {
    individual_own: 'Pessoal',
    individual_company: 'Individual',
    shared: 'Compartilhada',
    company_multi: 'Compartilhada',
  };

  return labels[type] || 'Tipo não identificado';
};

export const reconnectionResponsibleLabel = instance => {
  const responsible = instance?.reconnection_responsible_name;

  if (
    ['creator_or_manager', 'assignee_or_manager'].includes(
      instance?.reconnection_responsibility_kind
    )
  ) {
    return responsible
      ? `${responsible} ou gestor da empresa`
      : 'Gestor da empresa';
  }

  return responsible || 'Proprietário da instância';
};

export const disconnectedAlertSessionKey = (accountId, instanceId) =>
  `aceleres:disconnected-instance-alert:${accountId}:${instanceId}`;

// O painel de conversa do Funil abre o dashboard num iframe
// (`name="aceleres-funil-chat"`, ver aceleres-funil-chat-bridge.js). O aviso
// de instância caída cobre a conversa inteira nesse recorte; o aviso segue
// valendo na aba completa do Zoraxy. `window.name` atravessa origem cruzada
// (Funil no Aceleres + iframe no Zoraxy); `frameElement` não.
export const FUNIL_CHAT_FRAME_NAME = 'aceleres-funil-chat';

export const isFunilChatFrame = () => {
  try {
    return window.name === FUNIL_CHAT_FRAME_NAME;
  } catch (_error) {
    return false;
  }
};

export const wasDisconnectedAlertDismissed = ({
  storage,
  accountId,
  instanceId,
}) => {
  if (!storage) return false;

  return (
    storage.getItem(disconnectedAlertSessionKey(accountId, instanceId)) === '1'
  );
};

export const dismissDisconnectedAlert = ({
  storage,
  accountId,
  instanceId,
}) => {
  storage?.setItem(disconnectedAlertSessionKey(accountId, instanceId), '1');
};
